// import axios from "axios";
// import { store } from 'src/redux/store';

// export const API = axios.create({
//   baseURL: process.env.REACT_APP_CONSTANT_API_URL,
//   headers: {
//     "Content-Type": "application/json; charset=utf-8",
//   },
// });


// let customHeaders = {};
// const getAuthHeaders = () => {
//   const state = useSelector((state)=>state)
//   customHeaders =  {
//     message: state?.user?.signMessageData || undefined,
//     signature: state?.user?.signSignatureData || undefined,
//   };
// };


// export const callApi = async (

//   url,
//   method = "POST",
//   payload,
//   params = {},
// ) => {
//   try {
//     const resp = await API({
//       url,
//       method,
//       data: payload,
//       headers: customHeaders,
//       params,
//     });
//     return resp.data;
//   } catch (error) {
//     console.error("API call error:", error.response?.data || error.message);
//     throw error;
//   }
// };


import axios from "axios";
import {store} from '../../src/redux/Store'
export const API = axios.create({
  baseURL: process.env.REACT_APP_CONSTANT_API_URL,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

API.interceptors.request.use((config) => {
  const state = store.getState(); 
  const message = "Click to sign in to Golden Years." || undefined;
  const signature = state?.user?.signSignatureData || undefined;

  config.headers = {
    ...config.headers, 
    message,
    signature,
  };

  return config;
}, (error) => {
  return Promise.reject(error);
});

export const callApi = async (
  url,
  method = "POST",
  payload = {},
  params = {},
  customHeaders = {} 
) => {
  try {
    const resp = await API({
      url,
      method,
      data: payload,
      params,
      headers: customHeaders, 
    });

    return resp.data;
  } catch (error) {
    console.error("API call error:", error.response?.data || error.message);
    throw error;
  }
};

